import "./Logo.css";

const Logo = props => {
	return (
		<>
			<p className={props.className}>SILENT MOON</p>
		</>
	);
};

export default Logo;
